export default "__VITE_ASSET__CncrU$iz__"